module.exports = __webpack_public_path__ + "static/up-to-date-20169a4321b6d7c42f11c768b294e35e.png";